import { Component, Input, Output, EventEmitter } from '@angular/core';

import { ShareResultsService } from './share-results.service';
import { Trips } from './../shared/models/trip-models/trips';

@Component({
  selector: 'share-results',
  template: require('./share-results.component.html'),
  styles: [require('./share-results.component.scss')],
  providers: [ShareResultsService]
})
export class ShareResultsComponent {
  @Output() onClose = new EventEmitter();

  constructor(private service: ShareResultsService) {
  }

  @Input()
  set display(toDisplay: boolean) {
    this.service.show = toDisplay;
  }

  @Input()
  set id(id: string) {
    this.service.searchId = id;
  }

  @Input()
  set schedules(schedules: Trips) {
    this.service.emailBody = schedules.message;
    this.service.emailSubject = schedules.subject;
  }

  close() {
    this.onClose.emit();
  }

  share() {
    try {
      this.service.share().then(() => {
        setTimeout(() => {
          this.service.message = '';
          this.service.success = false;
          this.onClose.emit();
        }, 4000);
      }).catch(err => {
        this.service.message = 'Something went wrong. Please try again later.';
      });
    } catch (ex) {
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/share-results/share-results.component.ts